import {
  GetPlayersByPlayerIdLatestGameResponse,
  GetPlayersByPlayerIdStatsResponse,
  MachineInfo,
} from "@aura-frontend/omnibus-az-client";
import { create } from "zustand";
import { combine } from "zustand/middleware";

import { updateUrlParams } from "./utils";

// Helper to get URL params
export const getUrlParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    playerType:
      (searchParams.get("playerType") as "hitter" | "pitcher") || "hitter",
    dateFrom: searchParams.get("dateFrom") || undefined,
    dateTo: searchParams.get("dateTo") || undefined,
    gameType: (searchParams.get("gameType") as "game" | "practice") || "game",
    vsHand: (searchParams.get("vsHand") as "all" | "righty" | "lefty") || "all",
    selectedMachineUuid: searchParams.get("selectedMachine") || undefined,
  };
};

export const usePlayerProfileStore = create(
  combine(
    {
      ...getUrlParams(),
      selectedMachine: null as MachineInfo | null,
      pitcherGameData: undefined as
        | {
            latestGame: GetPlayersByPlayerIdLatestGameResponse;
            latestPractice: GetPlayersByPlayerIdLatestGameResponse;
            playerStats: GetPlayersByPlayerIdStatsResponse;
          }
        | undefined,

      hitterGameData: undefined as
        | {
            latestGame: GetPlayersByPlayerIdLatestGameResponse;
            latestPractice: GetPlayersByPlayerIdLatestGameResponse;
            playerStats: GetPlayersByPlayerIdStatsResponse;
          }
        | undefined,
    },
    (set) => ({
      setPlayerType: (playerType: "hitter" | "pitcher") => {
        updateUrlParams({ playerType });
        set({ playerType });
      },
      setDateFrom: (dateFrom: string | undefined) => {
        updateUrlParams({ dateFrom });
        set({ dateFrom });
      },
      setDateTo: (dateTo: string | undefined) => {
        updateUrlParams({ dateTo });
        set({ dateTo });
      },
      setGameType: (gameType: "game" | "practice") => {
        updateUrlParams({ gameType });
        set({ gameType });
      },
      setVsHand: (vsHand: "all" | "righty" | "lefty") => {
        updateUrlParams({ vsHand });
        set({ vsHand });
      },
      setSelectedMachine: (selectedMachine: MachineInfo | null) => {
        updateUrlParams({ selectedMachine: selectedMachine?.machine_uuid });
        set({ selectedMachine });
      },
      setPitcherGameData: (
        pitcherGameData:
          | {
              latestGame: GetPlayersByPlayerIdLatestGameResponse;
              latestPractice: GetPlayersByPlayerIdLatestGameResponse;
              playerStats: GetPlayersByPlayerIdStatsResponse;
            }
          | undefined,
      ) => set({ pitcherGameData }),
      setHitterGameData: (
        hitterGameData:
          | {
              latestGame: GetPlayersByPlayerIdLatestGameResponse;
              latestPractice: GetPlayersByPlayerIdLatestGameResponse;
              playerStats: GetPlayersByPlayerIdStatsResponse;
            }
          | undefined,
      ) => set({ hitterGameData }),
    }),
  ),
);
